import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionCTA } from '../SectionCTA';
import { faqs } from '../../data/content';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-mist px-5 py-16 md:py-24" aria-labelledby="faq-title" data-id="element-164" data-mp="2z2p5svgj77rq">
      <div className="mx-auto max-w-3xl" data-id="element-165" data-mp="3mst88zhzh1h5">
        <h2 id="faq-title" className="text-center font-display text-3xl font-black text-navy-900 sm:text-5xl" data-id="element-166" data-mp="3mtuorjhrqg69">
          Frequently Asked Questions
        </h2>

        <div className="mt-10 divide-y divide-navy-900/10 rounded-3xl bg-white px-5 ring-1 ring-black/5 sm:px-8" data-id="element-167" data-mp="3d39ozsqcz5lr">
          {faqs.map((faq, index) => {
          const isOpen = open === index;
          const panelId = `faq-panel-${index}`;
          return <div key={faq.question} data-id="element-168" data-mp="9k6pc3fnotr6" data-mpi={index}>
                <h3 data-id="element-169" data-mp="edjcsa8lmuic">
                  <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={panelId} className="flex w-full items-start justify-between gap-4 py-5 text-left font-display text-[17px] font-extrabold leading-snug text-navy-900" data-id="element-170" data-mp="ee1dpk67hwwl">
                    {faq.question}
                    <span className={`mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-[transform,background-color] duration-200 ease-out ${isOpen ? 'rotate-45 bg-pulse text-white' : 'bg-mist text-navy-900'}`} data-id="element-171" data-mp="25oi6snsigl3a">
                      <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-172" data-mp="2ogkjxp5y1j8s" />
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-173" data-mp="z1wiuk2sznq2">
                  {isOpen && <motion.div id={panelId} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-174" data-mp="u3bh2g7wkvzi">
                      <div className="space-y-3 pb-5 text-[16px] leading-relaxed text-muted" data-id="element-175" data-mp="1xr854yxsh0jw">
                        {faq.answer.map(p => <p key={p} data-id="element-176" data-mp="22ngsgzm54025">{p}</p>)}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <SectionCTA label="I’m ready — get my ECG Blueprint™" data-id="element-177" data-mp="2ggxzjkxn3kba" />
      </div>
    </section>;
}